import { http } from "@/lib/api";

const hasMeasurableStep = (steps = []) => steps.some((step) => {
  if ((step?.duration_seconds || 0) > 0 || (step?.distance_meters || 0) > 0) {
    return true;
  }
  return hasMeasurableStep(step?.substeps || []);
});

export const isWorkoutExportable = (session) => {
  if (!session) return false;
  if (String(session.role || "").toUpperCase() === "REST") return false;
  const steps = [
    ...(session.warmup || []),
    ...(session.main_set || []),
    ...(session.cooldown || []),
  ];
  if (!steps.length) return false;
  return hasMeasurableStep(steps);
};

export const downloadPlannedSessionExport = async (sessionId, format) => {
  const response = await http.get(
    `/training-block/planned-session/${encodeURIComponent(sessionId)}/export`,
    {
      params: { format },
      responseType: "blob",
    },
  );
  return response;
};

export const triggerWorkoutDownload = async (sessionId, format, workoutName) => {
  const response = await downloadPlannedSessionExport(sessionId, format);
  const blob = response.data;
  const disposition = response.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="([^"]+)"/i);
  const fallback = `${sessionId}.${format}`;
  const filename = match?.[1] || fallback;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return filename;
};
